import Image from 'next/image'
import React from 'react'
import { HStack } from '../../bases/HStack'
import { Text } from '../../bases/Text'
import { VStack } from '../../bases/VStack'
import { GlobalMenuButton } from '../GlobalMenuButton'
import akv from '../../../../../public/images/akv.png'
import iconMyAKIVERSE from '../../../../../public/images/iconMyAKIVERSE.png'
import iconMyAKIVERSEActive from '../../../../../public/images/iconMyAKIVERSEActive.png'
import iconGameCenter from '../../../../../public/images/iconGameCenter.png'
import iconGameCenterActive from '../../../../../public/images/iconGameCenterActive.png'
import iconArcade from '../../../../../public/images/iconArcade.png'
import iconArcadeActive from '../../../../../public/images/iconArcadeActive.png'
import iconAkiverseWorld from '../../../../../public/images/iconAkiverseWorld.png'
import iconAkiverseWorldActive from '../../../../../public/images/iconAkiverseWorldActive.png'
import iconPlayerManager from '../../../../../public/images/iconPlayerManager.png'
import iconPlayerManagerActive from '../../../../../public/images/iconPlayerManagerActive.png'
import iconDiscord from '../../../../../public/images/iconDiscord.png'
import iconDiscordActive from '../../../../../public/images/iconDiscordActive.png'
import iconSupportCenter from '../../../../../public/images/iconSupportCenter.png'
import iconSupportCenterActive from '../../../../../public/images/iconSupportCenterActive.png'
import iconLogout from '../../../../../public/images/iconLogout.png'
import iconLogoutActive from '../../../../../public/images/iconLogoutActive.png'
import QR from '../../../../../public/images/qrcode.png'
import AppStoreLogo from '../../../../../public/images/appStoreLogo.png'
import PlayStoreLogo from '../../../../../public/images/playStoreLogo.png'
import { Space } from '../../bases/Space'
import { useTranslation } from 'react-i18next'
import { Center } from '../../bases/Center'

export type Props = {
  isAdmin: boolean
  akvBalance: string
  onClickAkvLink: () => void
  activeMenu:
    | 'MyPage'
    | 'AkiverseWorld'
    | 'GameCenterManager'
    | 'ArcadeMachineManager'
    | 'PlayerManager'
    | 'BannerManager'
    | 'InterstitialBannerManager'
    | 'TournamentManager'
  onClickMyAkiverse: () => void
  onClickAkiverseWorld: () => void
  onClickArcadeMachineManager: () => void
  onClickGameCenterManager: () => void
  onClickPlayerManager: () => void
  onClickDiscord: () => void
  onClickSupportCenter: () => void
  onClickLogout: () => void
  onClickBannerManager: () => void
  onClickInterstitialBannerManager: () => void
  onClickTournamentManager: () => void
  disabled?: boolean
}

export const Layout: React.VFC<Props> = (props) => {
  const { t } = useTranslation()
  return (
    <VStack className="hidden_scroll_bar h-full w-full max-w-sm overflow-y-auto bg-menuBg">
      <VStack className="h-full w-full p-6 pb-3">
        <HStack className="h-16 w-full items-center rounded-xl border border-solid border-primary-textActive border-opacity-40 py-3 px-4">
          <Image src={akv} width={30} height={30} alt="akv" />
          <Text className="ml-3 flex-[0] text-sm font-bold text-primary-textActive">AKV</Text>
          <VStack className="ml-2 min-w-0 flex-1 items-end justify-end overflow-hidden text-ellipsis">
            <Text className="min-w-0 overflow-hidden text-ellipsis text-sm font-bold text-primary-textActive">
              ${`${props.akvBalance}`}
            </Text>
          </VStack>
          {/* <Clickable className="ml-2" onClick={props.onClickAkvLink}>
            <Image src={iconOpenWindow} width={20} height={20} alt="open akv window" />
          </Clickable> */}
        </HStack>
        <div className="my-5 min-h-[2px] w-full bg-gradient-to-r from-[#00FBEC00] via-[#00FBEC65] to-[#00FBEC00]" />
        <VStack className="mb-2">
          <GlobalMenuButton
            activeIconUrl={iconMyAKIVERSEActive}
            normalIconUrl={iconMyAKIVERSE}
            text={t('GlobalMenu.myAKIVERSEButton')}
            isActive={props.activeMenu === 'MyPage'}
            onClick={props.onClickMyAkiverse}
            disabled={props.disabled}
          />
        </VStack>
        <VStack className="mb-2 w-full">
          <GlobalMenuButton
            activeIconUrl={iconAkiverseWorldActive}
            normalIconUrl={iconAkiverseWorld}
            text={t('GlobalMenu.AkiverseWorldButton')}
            isActive={props.activeMenu === 'AkiverseWorld'}
            onClick={props.onClickAkiverseWorld}
            disabled={props.disabled}
          />
        </VStack>
        <VStack className="mb-2">
          <GlobalMenuButton
            activeIconUrl={iconGameCenterActive}
            normalIconUrl={iconGameCenter}
            text={t('GlobalMenu.gameCenterManagerButton')}
            isActive={props.activeMenu === 'GameCenterManager'}
            onClick={props.onClickGameCenterManager}
            disabled={props.disabled}
          />
        </VStack>
        <VStack className="mb-2">
          <GlobalMenuButton
            activeIconUrl={iconArcadeActive}
            normalIconUrl={iconArcade}
            text={t('GlobalMenu.arcadeMachineManagerButton')}
            isActive={props.activeMenu === 'ArcadeMachineManager'}
            onClick={props.onClickArcadeMachineManager}
            disabled={props.disabled}
          />
        </VStack>
        <VStack className="mb-2">
          <GlobalMenuButton
            activeIconUrl={iconPlayerManagerActive}
            normalIconUrl={iconPlayerManager}
            text={t('GlobalMenu.PlayerManagerButton')}
            isActive={props.activeMenu === 'PlayerManager'}
            onClick={props.onClickPlayerManager}
            disabled
            commingSoon
          />
        </VStack>
        <Text className="my-2 text-xs font-bold text-white opacity-60">
          {t('GlobalMenu.communitySectionLabel')}
        </Text>
        <VStack className="mb-2">
          <GlobalMenuButton
            activeIconUrl={iconDiscordActive}
            normalIconUrl={iconDiscord}
            text={t('GlobalMenu.DiscordButton')}
            onClick={props.onClickDiscord}
            isExtenalLink
            disabled={props.disabled}
          />
        </VStack>
        <VStack className="mb-2">
          <GlobalMenuButton
            activeIconUrl={iconSupportCenterActive}
            normalIconUrl={iconSupportCenter}
            text={t('GlobalMenu.SupportCenterButton')}
            onClick={props.onClickSupportCenter}
            isExtenalLink
            disabled={props.disabled}
          />
        </VStack>
        {props.isAdmin && (
          <>
            <Text className="my-2 text-xs font-bold text-white opacity-60">
              {t('GlobalMenu.admin.sectionLabel')}
            </Text>
            <VStack className="mb-2">
              <GlobalMenuButton
                text={t('GlobalMenu.admin.bannerButton')}
                onClick={props.onClickBannerManager}
                disabled={props.disabled}
                isActive={props.activeMenu === 'BannerManager'}
              />
            </VStack>
            <VStack className="mb-2">
              <GlobalMenuButton
                text={t('GlobalMenu.admin.interstitialBannerButton')}
                onClick={props.onClickInterstitialBannerManager}
                disabled={props.disabled}
                isActive={props.activeMenu === 'InterstitialBannerManager'}
              />
            </VStack>
            <VStack className="mb-2">
              <GlobalMenuButton
                text={t('GlobalMenu.admin.tournamentButton')}
                onClick={props.onClickTournamentManager}
                disabled={props.disabled}
                isActive={props.activeMenu === 'TournamentManager'}
              />
            </VStack>
          </>
        )}
        <Space />
        <Center className="flex-col rounded-xl border-[0.5px] border-solid border-akiverse-akir bg-black p-4">
          <Text className="text-center text-base font-bold text-akiverse-akir">
            {t('GlobalMenu.getAppTitle')}
          </Text>
          <Center className="relative my-3 h-12 w-40">
            <a
              href="https://play.google.com/store/apps/details?id=io.akiverse.arcade"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image src={PlayStoreLogo} layout="fill" alt="go to google play" />
            </a>
          </Center>
          <Center className="relative my-1 h-12 w-40">
            <Image src={AppStoreLogo} layout="fill" alt="go to app store" />
          </Center>
          <Text className="text-center text-base font-bold text-akiverse-akir">
            {t('GlobalMenu.qrTitle')}
          </Text>
          <Center className="relative my-3 aspect-square w-32">
            <Image src={QR} layout="fill" alt="qr" />
          </Center>
        </Center>
        <div className="mb-3 mt-8 min-h-[2px] w-full bg-gradient-to-r from-[#00FBEC00] via-[#00FBEC65] to-[#00FBEC00]" />
        <VStack className="mb-2">
          <GlobalMenuButton
            activeIconUrl={iconLogoutActive}
            normalIconUrl={iconLogout}
            text={t('GlobalMenu.LogoutButton')}
            onClick={props.onClickLogout}
            disabled={props.disabled}
          />
        </VStack>
      </VStack>
    </VStack>
  )
}
